import { GlobalConfiguration } from './state';
import { GlobalConfigurationAction } from './actions';

export const globalConfigurationReducer = (
  state: GlobalConfiguration,
  action: GlobalConfigurationAction
): GlobalConfiguration => {
  switch (action.type) {
    case 'SET_CONFIGURATION':
      return { ...state, configuration: action.payload };
  }
};
